import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import * as styles from "./Categories.module.scss";
import _ from "lodash";

const Categories = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(limit: 2000) {
        group(field: frontmatter___categories) {
          fieldValue
          totalCount
        }
      }
    }
  `);

  const [display, setDisplay] = useState(true);
  const handleMouseMove = (event) => {
    event.wheelDelta > 0 ? setDisplay(true) : setDisplay(false);
  };

  useEffect(() => {
    navigator.userAgent.toLowerCase().indexOf("firefox") > -1
      ? ""
      : window.addEventListener("wheel", handleMouseMove);

    // cleanup
    return () => {
      window.removeEventListener("wheel", handleMouseMove);
    };
  }, []);

  return (
    <nav className={styles.blogNav} style={{ opacity: `${display ? 1 : 0}` }}>
      <ul>
        {data.allMarkdownRemark.group.map((category) => (
          <li key={category.fieldValue}>
            <Link
              to={`/${_.kebabCase(category.fieldValue)}`}
              key={category.fieldValue}
              activeClassName={styles.activeNav}
            >
              {category.fieldValue}
              <strong> &nbsp; ({category.totalCount})</strong>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Categories;
